module.exports = __webpack_public_path__ + "static/media/username-password.bb0f8e09.png";